import { CSSProperties } from "react";
import { STACK_LAYERS } from "../../content/about";

/**
 * "Every layer of the stack": the layers drawn as brand tracks stacked like a
 * staircase, bottom → top, with the top layer (Growth ↺) in coral. A vertical
 * track on the right labelled "One team" spans them all, and a coral dot climbs
 * it. Layers slide in on load. Decorative — the same facts are in the text.
 */
const StackGraphic = () => {
  // Render top → bottom so the DOM reads Growth first, like a real stack.
  const layers = [...STACK_LAYERS].map((l, i) => ({ ...l, n: i + 1 })).reverse();
  return (
    <div className="is-stack-gfx" aria-hidden="true">
      <ol className="is-stack-gfx__layers">
        {layers.map((l, i) => (
          <li
            key={l.name}
            className={"is-stack-gfx__layer" + (i === 0 ? " is-stack-gfx__layer--top" : "")}
            style={{ ["--i" as string]: i } as CSSProperties}
          >
            <span className="is-stack-gfx__num">{String(l.n).padStart(2, "0")}</span>
            <span className="is-stack-gfx__name">
              {l.name}
              {i === 0 ? " ↺" : ""}
            </span>
            <span className="is-stack-gfx__note">{l.note}</span>
          </li>
        ))}
      </ol>
      <span className="is-stack-gfx__team">
        <span className="is-stack-gfx__runner" />
        <span className="is-stack-gfx__team-label">One team</span>
      </span>
    </div>
  );
};

export default StackGraphic;
